// **********************************************************
// Wishlist button
// **********************************************************
attachEvent('.wishlist-button', 'click', (ev) => {
  let productID = 0;
  const wishlistButtonEle = ev.target;
  const productCardEl = wishlistButtonEle.closest('.product-card');
  const productModuleEl = wishlistButtonEle.closest('.product-module');
  const productCartEl = wishlistButtonEle.closest('.cart-view__item');

  if (productCardEl) {
    productID = productCardEl.dataset.productId;
  } else if (productModuleEl) {
    productID = productModuleEl.querySelector('.product-id').value;
  } else if (productCartEl) {
    productID = productCartEl.querySelector('.product-id').value;
  }
  if (document.querySelector('.wishlist-module__main') && ev.target.closest('.sc-wishlist-module')) {
    productCardEl.style.display = 'none';
  }

  ev.preventDefault();
  const axiosData = new FormData();
  axiosData.append('action', 'toggleItemOnLikedList');
  axiosData.append('productid', productID);
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        wishlistButtonEle.closest('button').classList.toggle('is-active');
        // GA4 add_to_wishlist (samo ob dodajanju, ne ob odstranitvi)
        if (wishlistButtonEle.closest('button').classList.contains('is-active')) {
          const item = window.prowDL.itemFrom(wishlistButtonEle);
          if (item) window.prowDL.pushEcommerce('add_to_wishlist', { value: item.price, items: [item] });
        }
        const numberInHeaders = document.querySelectorAll('.header-main__heart .header-main__icon-items');
        numberInHeaders.forEach((numberInHeader) => {
          const count = response.data.data.wishlistCount;

          if (count === 0) {
            numberInHeader.style.display = 'none';
          } else {
            numberInHeader.style.display = '';
            numberInHeader.innerHTML = `<p>${count}</p>`;
          }
        });
      }
    });
});
